import "./CondoInspection.module.css";
import Header from "@/reusable_sections/Header";
import TajikistanHero from "./sections/TajikistanHero";
import TechnicalSpecifications from "./sections/TechnicalSpecifications";
import ExpertiseActionGrid from "./sections/ExpertiseActionGrid";
import OrderDirectly from "./sections/OrderDirectly";
import Footer from "@/reusable_sections/Footer";
export default function CondoInspectionPage() {
  return <div>
      <Header />
      <TajikistanHero />
      <TechnicalSpecifications />
      <ExpertiseActionGrid />
      <OrderDirectly />
      <Footer />
    </div>;
}